;(function (angular, _) {
  'use strict'
  angular.module('kilo.common.controllers')
    .controller('ChangeWorkspaceModalController', ChangeWorkspaceModalController)

  ChangeWorkspaceModalController.$inject = [
    // Angular
    // Libs
    '$uibModalInstance', 'zlAuth',
    // Managers
    // Services
    // Const
    // Resolved
    'selectedCompany', 'user'
  ]

  function ChangeWorkspaceModalController (
    // Angular
    // Libs
    $uibModalInstance, zlAuth,
    // Managers
    // Services
    // Const
    // Resolved
    selectedCompany, user
  ) {
    let self = this

    self.$onInit = () => {
      _.extend(self, {
        // Public Attributes
        workspaces: user.filteredCompanies,
        selectedCompany: selectedCompany,
        // Public Method
        changeWorkspace: changeWorkspace
      })
    }

    function changeWorkspace (id) {
      if (id === selectedCompany) {
        return
      }
      zlAuth.changeTeam(id)
    }
  }
})(window.angular, window._)
